import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";

import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";

//Home Sections
import IntroVideoSection from "views/home/introSection/Index";
import AboutIndexSection from "views/home/aboutSection/Index";
import AnalyticsSection from "views/home/analyticsSection/Index";
import NewsletterSection from "views/home/newsletterSection/Index";
import ContactSection from "views/home/contactSection/Index";
import IdentitySection from "views/home/identitySection/Index";

//contact
import Contact from "views/contactUs/Index";
import Show from "views/contactUs/Show";

//settings
import Settings from "views/settings/Index";

//services
import Services from "views/services/Index";
import AddService from "views/services/Add";
import EditService from "views/services/Edit";

//works
import Works from "views/works/Index";
import AddWork from "views/works/Add";
import EditWork from "views/works/Edit";

//clients
import Clients from "views/clients/Index";
import AddClient from "views/clients/Add";
import EditClient from "views/clients/Edit";

//categories
import Categories from "views/categories/Index";
import AddCategory from "views/categories/Add";
import EditCategory from "views/categories/Edit";

//subscribers
import Subscribers from "views/subscribers/Index";

//admins
import Admins from "views/admins/Index";
import AddAdmin from "views/admins/Add";
import EditAdmin from "views/admins/Edit";

//profile
import Profile from "views/profile";
import UpdatePassWord from "views/change-password";

//auth
import ForgetPassword from "views/forget-password";
import ResetPassword from "views/reset-password";

//socialLinks
import SocialLinks from "views/socialLinks/Index";
import AddSocialLink from "views/socialLinks/Add";
import EditSocialLink from "views/socialLinks/Edit";

const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              {/*Home Sections */}
              <Route path="/home/intro" element={<IntroVideoSection />} />
              <Route path="/home/about" element={<AboutIndexSection />} />
              <Route path="/home/analytics" element={<AnalyticsSection />} />
              <Route path="/home/newsletter" element={<NewsletterSection />} />
              <Route path="/home/contact" element={<ContactSection />} />
              <Route path="/about/identity" element={<IdentitySection />} />

              {/* contact */}
              <Route path="/contact" element={<Contact />} />
              <Route path="/contact/show/:id" element={<Show />} />

              {/* settings */}
              <Route path="/settings" element={<Settings />} />

              {/*services */}
              <Route path="/services" element={<Services />} />
              <Route path="/services/add" element={<AddService />} />
              <Route path="/services/:id" element={<EditService />} />

              {/*works */}
              <Route path="/works" element={<Works />} />
              <Route path="/works/add" element={<AddWork />} />
              <Route path="/works/:id" element={<EditWork />} />

              {/*clients */}
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/add" element={<AddClient />} />
              <Route path="/clients/:id" element={<EditClient />} />

              {/*categories */}
              <Route path="/categories" element={<Categories />} />
              <Route path="/categories/add" element={<AddCategory />} />
              <Route path="/categories/:id" element={<EditCategory />} />

              {/*subscribers */}
              <Route path="/subscribers" element={<Subscribers />} />

              {/*admins */}
              <Route path="/admins" element={<Admins />} />
              <Route path="/admins/add" element={<AddAdmin />} />
              <Route path="/admins/:id" element={<EditAdmin />} />

              {/*profile */}
              <Route path="/profile" element={<Profile />} />
              <Route path="/change-password" element={<UpdatePassWord />} />

              {/*socialLinks */}
              <Route path="/social-links" element={<SocialLinks />} />
              <Route path="/social-links/add" element={<AddSocialLink />} />
              <Route path="/social-links/:id" element={<EditSocialLink />} />

              {/*404 */}
              <Route path="*" element={<NotFound />} />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login />
                </GuestRoute>
              }
            />
            <Route
              path="/forget-password"
              element={
                <GuestRoute>
                  <ForgetPassword />
                </GuestRoute>
              }
            />
            <Route
              path="/reset-password"
              element={
                <GuestRoute>
                  <ResetPassword />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
